// Country-specific mileage copy (generated from design_guidelines.json). Statutory = an official flat rate exists.
export const MILEAGE_COUNTRY = {
  "GB": {
    "country_name": "United Kingdom",
    "authority": "HMRC",
    "statute_title": "ITEPA 2003 s.230 Approved Mileage Allowance Payments (AMAP)",
    "home_shortcut_subtitle": "45p/mi up to 10k miles · HMRC approved",
    "more_tools_description": "Claim 45p/mile (25p over 10k mi) plus 5p passenger allowance under HMRC AMAP rules and post directly to drawings or payroll.",
    "page_hero_copy": "HMRC-approved rate logging: 45p/mile for the first 10,000 tax-year business miles, 25p thereafter, plus 5p per passenger. Claims post automatically to your books.",
    "rule_badge": "HMRC 45p/25p Tier Ladder",
    "cap_or_tier_rule": "First 10,000 miles per tax year (starting 6 April) priced at £0.45; £0.25 thereafter. Motorcycle @ 24p, Bicycle @ 20p.",
    "owner_rule": "Sole traders/partners using the flat rate cannot also deduct actual vehicle running costs or claim capital allowances on that vehicle.",
    "statutory": true
  },
  "US": {
    "country_name": "United States",
    "authority": "IRS",
    "statute_title": "IRS Standard Mileage Rate 2026 (Notice 2026-10 & Ann. 2026-11)",
    "home_shortcut_subtitle": "72.5¢ → 76¢/mi mid-year rate · IRS compliant",
    "more_tools_description": "Track business miles at the 2026 IRS rate (72.5¢ Jan–Jun, 76¢ Jul–Dec) and post to owner equity or employee payables.",
    "page_hero_copy": "IRS 2026 standard mileage tracking: 72.5¢/mile through June 30, shifting to 76.0¢/mile from July 1, 2026. Automated calendar-year calculation and journal posting.",
    "rule_badge": "IRS 2026 Mid-Year Rate Switch",
    "cap_or_tier_rule": "72.5¢/mi for trips Jan 1 – Jun 30, 2026; 76.0¢/mi for trips Jul 1 – Dec 31, 2026.",
    "owner_rule": "Standard mileage method: no separate deduction for actual car expenses or depreciation (MACRS/§179) on that vehicle; must be elected in year one.",
    "statutory": true
  },
  "CA": {
    "country_name": "Canada",
    "authority": "CRA",
    "statute_title": "CRA Reasonable Per-Kilometre Allowance 2026 (ITR 7306)",
    "home_shortcut_subtitle": "73¢ first 5,000 km, 67¢ after · CRA rates",
    "more_tools_description": "Log business travel using CRA 2026 per-km limits (73¢ first 5,000 km, 67¢ after, +4¢ territories) with full logbook compliance.",
    "page_hero_copy": "CRA 2026 statutory rates: 73¢/km for the first 5,000 calendar-year business km, 67¢/km thereafter (+4¢ in NT/YT/NU). Tax-free reimbursement ceiling.",
    "rule_badge": "CRA 73¢/67¢ 5,000 km Tier",
    "cap_or_tier_rule": "73¢/km for first 5,000 km; 67¢/km thereafter. Calendar year basis.",
    "owner_rule": "Self-employed owners deduct actual vehicle costs pro-rated by business km (logbook mandatory); rate represents tax-free employee reimbursement limit.",
    "statutory": true
  },
  "AU": {
    "country_name": "Australia",
    "authority": "ATO",
    "statute_title": "ATO Cents per Kilometre Method 2026–27 (ITAA 1997 s.28-25)",
    "home_shortcut_subtitle": "91c/km capped at 5,000 km · ATO approved",
    "more_tools_description": "Record business travel at ATO's 91c/km statutory rate up to the strict 5,000 km annual cap before switching to logbook actual cost.",
    "page_hero_copy": "ATO 2026–27 cents per kilometre method: 91c/km up to a strict 5,000 business km cap per vehicle per tax year (starting July 1). Trips past 5,000 km switch to actual-cost logbook tracking.",
    "rule_badge": "ATO 91c/km (5,000 km Cap)",
    "cap_or_tier_rule": "91c/km up to 5,000 km limit per tax year (1 July – 30 June). No allowance paid above 5,000 km without logbook method.",
    "owner_rule": "Above 5,000 km use the logbook (actual cost) method; the cents-per-km rate already covers depreciation and running costs.",
    "statutory": true
  },
  "ZA": {
    "country_name": "South Africa",
    "authority": "SARS",
    "statute_title": "SARS Prescribed Rate per Kilometre 2025/26 (ITA s.8(1)(b)(iii))",
    "home_shortcut_subtitle": "R4.76/km prescribed rate · SARS compliant",
    "more_tools_description": "Log business travel against the SARS R4.76/km prescribed rate with automated logbook compliance and tax-free threshold tracking.",
    "page_hero_copy": "SARS prescribed travel reimbursement: R4.76 per business kilometre for the tax year (starting 1 March). Tax-exempt up to 12,000 km where no other travel allowance is paid.",
    "rule_badge": "SARS R4.76/km Prescribed Rate",
    "cap_or_tier_rule": "R4.76/km flat rate for reimbursive travel. Tax year 1 March to 28/29 February.",
    "owner_rule": "Sole proprietors deduct actual vehicle costs apportioned by logbook; the prescribed rate applies to reimbursive staff allowances.",
    "statutory": true
  },
  "DE": {
    "country_name": "Germany",
    "authority": "BMF / Finanzamt",
    "statute_title": "Kilometerpauschale §9 Abs. 1 Nr. 4a EStG / BRKG §5",
    "home_shortcut_subtitle": "€0.30/km Dienstreise Pauschale · BMF standard",
    "more_tools_description": "Record business travel (Dienstreisen) at the German statutory €0.30/km flat rate for private vehicles or €0.20/km for motorbikes.",
    "page_hero_copy": "German Kilometerpauschale: €0.30 per business km for private cars (€0.20 for motorbikes) under §9 EStG. Posts directly to operating motor expenses.",
    "rule_badge": "BMF €0.30/km Pauschale",
    "cap_or_tier_rule": "€0.30/km flat rate for cars; €0.20/km for motorcycles. Calendar year.",
    "owner_rule": "Owner may use the €0.30 Pauschale for private-car business trips or actual costs with a compliant Fahrtenbuch - not both.",
    "statutory": true
  },
  "NL": {
    "country_name": "Netherlands",
    "authority": "Belastingdienst",
    "statute_title": "Onbelaste kilometervergoeding (Wet LB art. 31a)",
    "home_shortcut_subtitle": "€0.23/km onbelaste vergoeding · Belastingdienst",
    "more_tools_description": "Claim the Dutch statutory tax-free €0.23/km travel allowance for private car business travel and automatically reconcile claims.",
    "page_hero_copy": "Belastingdienst onbelaste kilometervergoeding: €0.23 per business km for private vehicle travel. Deductible for IB-ondernemers and tax-free for employee reimbursement.",
    "rule_badge": "Belastingdienst €0.23/km",
    "cap_or_tier_rule": "€0.23/km flat rate for business travel with private vehicle. Calendar year.",
    "owner_rule": "Zelfstandigen with a private car deduct €0.23 per business km; a car registered in the business claims actual costs with bijtelling.",
    "statutory": true
  },
  "FR": {
    "country_name": "France",
    "authority": "DGFiP",
    "statute_title": "Barème kilométrique officiel 5 CV (BOI-BAREME-000001)",
    "home_shortcut_subtitle": "Barème kilométrique 5 CV · DGFiP compliant",
    "more_tools_description": "Calculate French business mileage using official DGFiP 3-tier barème curves (0.636€ up to 5k km, 0.357€+1,395€, 0.427€).",
    "page_hero_copy": "DGFiP Barème kilométrique: 3-tier bracket system for 5 CV vehicles (0.636€ ≤ 5,000 km, 0.357€ + fixed bracket bonus 5,001–20,000 km, 0.427€ above 20,000 km).",
    "rule_badge": "DGFiP Barème Kilométrique (5 CV)",
    "cap_or_tier_rule": "Tier 1 (≤5,000 km): 0.636€/km; Tier 2 (5,001–20,000 km): (0.357€ × d) + 1,395€; Tier 3 (>20,000 km): 0.427€/km.",
    "owner_rule": "BNC/BIC owners may use the barème instead of actual costs for a private vehicle; the election applies for the entire tax year.",
    "statutory": true
  },
  "IE": {
    "country_name": "Ireland",
    "authority": "Revenue Commissioners",
    "statute_title": "Revenue Civil Service Motor Travel Rates (1,201–1,500cc)",
    "home_shortcut_subtitle": "Civil service 4-band rates · Revenue approved",
    "more_tools_description": "Reimburse travel at Irish Revenue civil service 4-tier rates (41.8c first 1,500 km, 72.6c up to 5,500 km, stepping down after).",
    "page_hero_copy": "Irish Revenue civil service travel rates: 4 progressive cumulative distance bands (41.80c first 1,500 km, 72.64c up to 5,500 km, 31.78c up to 25,000 km, 20.56c thereafter).",
    "rule_badge": "Revenue 4-Tier Bands (1,201-1,500cc)",
    "cap_or_tier_rule": "0–1,500 km @ €0.418; 1,501–5,500 km @ €0.7264; 5,501–25,000 km @ €0.3178; 25,001+ km @ €0.2056.",
    "owner_rule": "Self-employed owners deduct actual motor expenses apportioned to business use; civil-service rates serve as employee reimbursement ceilings.",
    "statutory": true
  },
  "NG": {
    "country_name": "Nigeria",
    "authority": "FIRS / NTA 2025",
    "statute_title": "NTA 2025 s.20 Wholly & Exclusively Incurred Business Travel",
    "home_shortcut_subtitle": "Custom business reimbursement · NTA 2025 logbook",
    "more_tools_description": "Set your business reimbursement rate per km (no statutory flat rate), log trips for audit compliance, and post claims to your books.",
    "page_hero_copy": "Nigeria business mileage tracking: Set company reimbursement rates per km with mandatory digital trip logging under NTA 2025 s.20 actual-cost deductibility.",
    "rule_badge": "Custom Business Rate (NTA 2025 Logbook)",
    "cap_or_tier_rule": "No statutory rate. Businesses define per-vehicle reimbursement rates; tax deductibility requires logged business purpose and distance.",
    "owner_rule": "Deduct actual vehicle costs apportioned to business use via trip log; define an agreed reimbursement rate for company staff.",
    "statutory": false
  },
  "GH": {
    "country_name": "Ghana",
    "authority": "GRA",
    "statute_title": "Income Tax Act 2015 (Act 896 s.9)",
    "home_shortcut_subtitle": "Custom business reimbursement · GRA logbook",
    "more_tools_description": "Set vehicle-specific reimbursement rates per km and maintain a tax-compliant business travel log under GRA rules.",
    "page_hero_copy": "Ghana business mileage: Configure company reimbursement rates per km and maintain audit-proof travel logs under Act 896 s.9.",
    "rule_badge": "Custom Business Rate (GRA Logbook)",
    "cap_or_tier_rule": "No statutory flat rate. Business sets per-km rate; GRA requires logbook proof for deductibility.",
    "owner_rule": "Actual-cost method with logbook apportionment for owners; staff reimbursed at company-specified rates.",
    "statutory": false
  },
  "KE": {
    "country_name": "Kenya",
    "authority": "KRA",
    "statute_title": "Income Tax Act s.15 (Wholly and Exclusively Incurred)",
    "home_shortcut_subtitle": "Custom or AA Kenya rates · KRA logbook",
    "more_tools_description": "Track business travel using company-defined or AA Kenya benchmark rates per km, posting verified claims directly to the ledger.",
    "page_hero_copy": "Kenya business travel log: Track trips against internal company rates or AA Kenya benchmarks with full KRA s.15 deductibility documentation.",
    "rule_badge": "Custom / AA Kenya Benchmark Rate",
    "cap_or_tier_rule": "No statutory per-km rate. AA Kenya rates or business-defined rates supported; travel logs mandatory.",
    "owner_rule": "Actual-cost method with logbook for self-employed; company rates apply to employee reimbursements.",
    "statutory": false
  },
  "TZ": {
    "country_name": "Tanzania",
    "authority": "TRA",
    "statute_title": "Income Tax Act 2004 s.11",
    "home_shortcut_subtitle": "Custom business reimbursement · TRA logbook",
    "more_tools_description": "Define business mileage reimbursement per km with full logbook records for TRA tax deductibility.",
    "page_hero_copy": "Tanzania mileage log: Record business travel at your agreed company rate per km with TRA-compliant audit trails.",
    "rule_badge": "Custom Business Rate (TRA Logbook)",
    "cap_or_tier_rule": "No statutory flat rate. Reimbursements follow agreed company rates and actual cost logbook rules.",
    "owner_rule": "Actual-cost method with logbook for business vehicles.",
    "statutory": false
  },
  "UG": {
    "country_name": "Uganda",
    "authority": "URA",
    "statute_title": "Income Tax Act Cap 340 s.22",
    "home_shortcut_subtitle": "Custom business reimbursement · URA logbook",
    "more_tools_description": "Log business travel and reimburse employees or owners at company-set rates with URA tax compliance.",
    "page_hero_copy": "Uganda business mileage tracking: Set custom per-km reimbursement rates with digital travel logging under URA Cap 340 s.22.",
    "rule_badge": "Custom Business Rate (URA Logbook)",
    "cap_or_tier_rule": "No statutory flat rate. Custom rate set per vehicle; tax year starts 1 July.",
    "owner_rule": "Actual-cost method with trip log apportionment.",
    "statutory": false
  },
  "RW": {
    "country_name": "Rwanda",
    "authority": "RRA",
    "statute_title": "Law 027/2022 art. 22 Business Expense Rules",
    "home_shortcut_subtitle": "Custom business reimbursement · RRA logbook",
    "more_tools_description": "Record business travel at company rates with compliant trip logs and instant journal posting under RRA guidelines.",
    "page_hero_copy": "Rwanda travel log: Set company vehicle rates per km and maintain digital trip logs satisfying RRA Law 027/2022 art. 22 audit standards.",
    "rule_badge": "Custom Business Rate (RRA Logbook)",
    "cap_or_tier_rule": "No statutory flat rate. Business determines reimbursement rate; logbook required.",
    "owner_rule": "Actual business expenses substantiated with travel logs.",
    "statutory": false
  },
  "IN": {
    "country_name": "India",
    "authority": "Income Tax Department",
    "statute_title": "Income-tax Act 1961 s.37(1) Conveyance Allowance",
    "home_shortcut_subtitle": "Custom conveyance rate · IT Act s.37(1) logbook",
    "more_tools_description": "Set conveyance rates per km for owner drawings or employee travel, logging routes for Section 37(1) tax exemption.",
    "page_hero_copy": "India business conveyance log: Define per-km vehicle reimbursement rates with Section 37(1) compliant digital trip documentation. Tax year runs 1 April to 31 March.",
    "rule_badge": "Custom Conveyance Rate (IT Act s.37(1))",
    "cap_or_tier_rule": "No statutory per-km rate. Conveyance allowance is exempt to the extent actually incurred for official duties with logbook support.",
    "owner_rule": "Actual-cost method with logbook; motor car depreciation claimable at 15% WDV.",
    "statutory": false
  }
};

export const GENERIC_MILEAGE = {
  country_name: 'your country', authority: 'Tax authority', statute_title: 'Business travel deduction',
  home_shortcut_subtitle: 'Log trips · claim at your rate', more_tools_description: 'Log business trips, set your reimbursement rate and post claims to the books.',
  page_hero_copy: 'Log business trips, apply your reimbursement rate and post the claim to your books.',
  rule_badge: 'Business reimbursement rate', cap_or_tier_rule: 'No statutory rate - the business sets its own rate per vehicle.', owner_rule: '', statutory: false,
};

export const mileageCopy = (country) => MILEAGE_COUNTRY[(country || '').toUpperCase()] || GENERIC_MILEAGE;
export const isStatutoryMileageCountry = (country) => !!MILEAGE_COUNTRY[(country || '').toUpperCase()]?.statutory;
